import Vue from 'vue';
import '../common';

new Vue({
  components: {},
}).$mount('#app');
